import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import { SpecialPackCollections_collections } from "../../../types/__generated__/SpecialPackCollections";
import { SpecialPackProduct } from "../../../types/__generated__/SpecialPackProduct";
import URL_PATTERNS from "../../../urls";
import ArrowNavigator from "../../atoms/ArrowNavigator";
import SpecialPackProductCard from "../../molecules/SpecialPackProductCard";
import {
  ArrowNavigatorWrapper,
  HorizontalContainer,
  StyledProductCollectionGalleryHolder,
  StyledTitle,
  TopSection,
  TopSeeAllText,
} from "../ProductCollectionGallerySection/style";

const Products = styled(HorizontalContainer)`
  align-items: stretch;
  gap: 20px;
`;

interface SpecialPackCollectionGalleryProps {
  collection: SpecialPackCollections_collections;
  onAdd?: (product: SpecialPackProduct) => void;
}

const SpecialPackCollectionGallery = ({ collection, onAdd }: SpecialPackCollectionGalleryProps) => {
  const { t } = useTranslation(I18N_NAMESPACES.COMMON);
  const horizontalContainer = useRef<HTMLDivElement>(null);

  return (
    <StyledProductCollectionGalleryHolder as="section" aria-label={collection.name}>
      <TopSection>
        <StyledTitle>{collection.name}</StyledTitle>
        <ArrowNavigatorWrapper>
          <TopSeeAllText to={URL_PATTERNS.SPECIAL_PACK_COLLECTION(collection.slug)}>
            {t("common:seeAll")}
          </TopSeeAllText>
          <ArrowNavigator horizontalContainer={horizontalContainer} scrollAdjustment={20} />
        </ArrowNavigatorWrapper>
      </TopSection>
      {collection.description && <p>{collection.description}</p>}
      <Products ref={horizontalContainer} showProductsOnSingleRow>
        {collection.products?.map(
          (product) =>
            product && (
              <SpecialPackProductCard key={product.slug} product={product} isInCollection onAdd={onAdd} />
            )
        )}
      </Products>
    </StyledProductCollectionGalleryHolder>
  );
};

export default SpecialPackCollectionGallery;
